import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer, faInbox } from "@instadeepai/fontawesome-pro-regular";
import { Button } from "@shared/ui";
import { StatusBadge } from "@/components/status-badge";
import { ROUTES } from "@/consts";

export const EmptyForge = () => {
    return (
        <div className="flex flex-col justify-center items-center gap-8 h-full">
            <div className="flex flex-col items-center gap-3 text-center">
                <StatusBadge variant="secondary" className="!border-[#F178B6] !text-[#F178B6] !text-sm" leftIcon={<FontAwesomeIcon icon={faInbox} size="1x" />}>
                    Empty
                </StatusBadge>
                <div className="flex flex-col gap-1">
                    <h2 className="font-semibold text-[30px]">No Forge in Progress</h2>
                    <p className="text-[#364152] text-sm">
                        The ship is Idle – start a new forge
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-1">
                <Link href={ROUTES.SELECT_FORGE_TYPE}>
                    <Button variant="primary" rightIcon={<FontAwesomeIcon icon={faHammer} size="1x" />}>
                        Start Forge
                    </Button>
                </Link>
            </div>
        </div>
    );
}